import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Input, Button, Table, message, Form, Space, Typography, Tag, Spin } from "antd";
import { DeleteOutlined, PlusOutlined, SaveOutlined, ReloadOutlined } from "@ant-design/icons";
import { getCaseSummaryApi, createCaseSummaryApi } from '../../../api/master.api';

const { Title } = Typography;

const EditableCaseTable = () => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Header fields
    const [month1, setMonth1] = useState('আগস্ট');
    const [year1, setYear1] = useState('২০২৫');
    const [date1, setDate1] = useState('০১ জুলাই ২০২৫');
    const [date2, setDate2] = useState('আগস্ট ২০২৫');

    // Signatory fields
    const [signatoryName, setSignatoryName] = useState('');
    const [signatoryDesignation, setSignatoryDesignation] = useState('');
    const [signatoryDepartment, setSignatoryDepartment] = useState('');

    // Section 1 - High Court Data
    const [section1Data, setSection1Data] = useState([
        { key: '1', serial: '১।', division: 'আপিল বিভাগ', col1: '০৩', col2: '০৫', col3: '-', col4: '-', col5: '০৫', remark: '-' },
        { key: '2', serial: '২।', division: 'হাইকোর্ট বিভাগ', col1: '০১', col2: '০২', col3: '০১', col4: '-', col5: '৩৫', remark: '-' }
    ]);
    const [section1Total, setSection1Total] = useState('৩৭');

    // Section 2 - Arbitration Tribunal Data
    const [section2Data, setSection2Data] = useState([
        { key: '1', serial: '১।', division: 'Arising out of Arbitration Misc. Case No. 340 of 2015', col1: '০০', col2: '০১', col3: '-', col4: '-', col5: '০১', remark: '-' }
    ]);

    // Section 3 - Lower Court Data
    const [section3Data, setSection3Data] = useState([
        { key: '1', serial: '১।', division: 'ঢাকা দক্ষিণ জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০৪', col3: '-', col4: '-', col5: '০৪', remark: 'চলমান মামলা:\nCR (ST Act) ১২৪০/১৭: ০১টি\nদেওয়ানী মোকদ্দমা ৬৬/২২: ০১টি' },
        { key: '2', serial: '২।', division: 'মুন্সীগঞ্জ জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০১', col3: '-', col4: '-', col5: '০১', remark: 'চলমান মামলা:\nদেওয়ানী আপীল মোকদ্দমা: ০১টি' },
        { key: '3', serial: '৩।', division: 'চট্টগ্রাম জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০৩', col3: '-', col4: '-', col5: '০৩', remark: 'চলমান মামলা:\nআরবিট্রেশন মিস কেস: ১০/২০১৬:১টি' },
        { key: '4', serial: '৪।', division: 'টাঙ্গাইল জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '১৮৬', col3: '-', col4: '-', col5: '১৮৬', remark: 'চলমান মামলা:\nঅন্না প্রকার মোকদ্দমা: ০৬টি\nমঞ্জু মোহাখালি মোকদ্দমা : ১২৯টি' }
    ]);
    const [section3Total, setSection3Total] = useState('১৯৪');
    const [grandTotal, setGrandTotal] = useState('(৩৭+১+১৯৪) =২৩২');

    // Fetch existing data
    useEffect(() => {
        const fetchCaseSummary = async () => {
            setLoading(true);
            try {
                const { data } = await getCaseSummaryApi();
                // console.log(data);
                const items = data.data || [];
                // console.log(items);
                if (items && items.length > 0) {
                    const latestData = items[0];
                    // console.log("latestData", latestData);
                    // Header info
                    setMonth1(latestData.month || 'আগস্ট');
                    setYear1(latestData.year || '২০২৫');
                    setDate1(latestData.date1 || '০১ জুলাই ২০২৫');
                    setDate2(latestData.date2 || 'আগস্ট ২০২৫');

                    // Table data
                    setSection1Data(latestData.section1Data || latestData.SECTION1_DATA ? latestData.section1Data : section1Data);
                    setSection2Data(latestData.section2Data || latestData.SECTION2_DATA ? latestData.section2Data : section2Data);
                    setSection3Data(latestData.section3Data || latestData.SECTION3_DATA ? latestData.section3Data : section3Data);

                    // Totals
                    setSection1Total(latestData.section1Total || latestData.SECTION1_TOTAL || '৩৭');
                    setSection3Total(latestData.section3Total || latestData.SECTION3_TOTAL || '১৯৪');
                    setGrandTotal(latestData.grandTotal || latestData.GRAND_TOTAL || '(৩৭+১+১৯৪) =২৩২');

                    // Signatory info
                    setSignatoryName(latestData.name || latestData.NAME || '');
                    setSignatoryDesignation(latestData.designation || latestData.DESIGNATION || '');
                    setSignatoryDepartment(latestData.department || latestData.DEPARTMENT || '');
                }
            } catch (error) {
                console.error(error);
                message.error("ডাটা লোড করা যায়নি");
            } finally {
                setLoading(false);
            }
        };

        fetchCaseSummary();
    }, []);
    // console.log("section1Data", section1Data);
    // Update functions
    const update = (section, index, field, value) => {
        const setter = section === 1 ? setSection1Data : section === 2 ? setSection2Data : setSection3Data;
        const data = section === 1 ? section1Data : section === 2 ? section2Data : section3Data;
        const newData = [...data];
        newData[index][field] = value;
        setter(newData);
    };

    const addRow = (section) => {
        const setter = section === 1 ? setSection1Data : section === 2 ? setSection2Data : setSection3Data;
        const data = section === 1 ? section1Data : section === 2 ? section2Data : section3Data;
        const newKey = Date.now().toString();
        setter([...data, {
            key: newKey,
            serial: `${data.length + 1}।`,
            division: '',
            col1: '',
            col2: '',
            col3: '',
            col4: '',
            col5: '',
            remark: ''
        }]);
    };

    const removeRow = (section, index) => {
        const setter = section === 1 ? setSection1Data : section === 2 ? setSection2Data : setSection3Data;
        const data = section === 1 ? section1Data : section === 2 ? section2Data : section3Data;
        if (data.length > 1) {
            const newData = data.filter((_, i) => i !== index);
            const updatedData = newData.map((item, idx) => ({
                ...item,
                serial: `${idx + 1}।`
            }));
            setter(updatedData);
        }
    };

    const handleReset = () => {
        setMonth1('আগস্ট');
        setYear1('২০২৫');
        setDate1('০১ জুলাই ২০২৫');
        setDate2('আগস্ট ২০২৫');
        setSection1Data([
            { key: '1', serial: '১।', division: 'আপিল বিভাগ', col1: '০৩', col2: '০৫', col3: '-', col4: '-', col5: '০৫', remark: '-' },
            { key: '2', serial: '২।', division: 'হাইকোর্ট বিভাগ', col1: '০১', col2: '০২', col3: '০১', col4: '-', col5: '৩৫', remark: '-' }
        ]);
        setSection2Data([
            { key: '1', serial: '১।', division: 'Arising out of Arbitration Misc. Case No. 340 of 2015', col1: '০০', col2: '০১', col3: '-', col4: '-', col5: '০১', remark: '-' }
        ]);
        setSection3Data([
            { key: '1', serial: '১।', division: 'ঢাকা দক্ষিণ জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০৪', col3: '-', col4: '-', col5: '০৪', remark: 'চলমান মামলা:\nCR (ST Act) ১২৪০/১৭: ০১টি\nদেওয়ানী মোকদ্দমা ৬৬/২২: ০১টি' },
            { key: '2', serial: '২।', division: 'মুন্সীগঞ্জ জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০১', col3: '-', col4: '-', col5: '০১', remark: 'চলমান মামলা:\nদেওয়ানী আপীল মোকদ্দমা: ০১টি' },
            { key: '3', serial: '৩।', division: 'চট্টগ্রাম জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '০৩', col3: '-', col4: '-', col5: '০৩', remark: 'চলমান মামলা:\nআরবিট্রেশন মিস কেস: ১০/২০১৬:১টি' },
            { key: '4', serial: '৪।', division: 'টাঙ্গাইল জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালত', col1: '০', col2: '১৮৬', col3: '-', col4: '-', col5: '১৮৬', remark: 'চলমান মামলা:\nঅন্না প্রকার মোকদ্দমা: ০৬টি\nমঞ্জু মোহাখালি মোকদ্দমা : ১২৯টি' }
        ]);
        setSection1Total('৩৭');
        setSection3Total('১৯৪');
        setGrandTotal('(৩৭+১+১৯৪) =২৩২');
        setSignatoryName('');
        setSignatoryDesignation('');
        setSignatoryDepartment('');
        message.info("ফর্ম রিসেট করা হয়েছে");
    };
    //    console.log(section1Data, section2Data, section3Data);
    const handleSubmit = async () => {
        setSubmitting(true);
        try {
            const allData = {
                month: month1,
                year: year1,
                date1: date1,
                date2: date2,
                section1Data,
                section2Data,
                section3Data,
                section1Total,
                section3Total,
                grandTotal,
                createdBy: 'SYSTEM',
                name: signatoryName,
                designation: signatoryDesignation,
                department: signatoryDepartment
            };

            await createCaseSummaryApi(allData);
            message.success("তথ্য সফলভাবে সংরক্ষণ করা হয়েছে");
        } catch (err) {
            console.error(err);
            message.error("সংরক্ষণ ব্যর্থ হয়েছে");
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin size="large" tip="লোড হচ্ছে..." />
            </div>
        );
    }

    return (
        <div style={{ background: "#f0f2f5", minHeight: "100vh", padding: "24px" }}>
            <div style={{ maxWidth: 1400, margin: "0 auto" }}>
                {/* Header */}
                <Card style={{ marginBottom: 24, borderRadius: 12 }}>
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Title level={3} style={{ margin: 0, color: "#1a5f7a" }}>
                                মামলা সংক্রান্ত তথ্য এন্ট্রি
                            </Title>
                            <Tag color="blue" style={{ marginTop: 8 }}>
                                কেস সামারি ফর্ম
                            </Tag>
                        </Col>
                    </Row>
                </Card>

                <Form
                    layout="vertical"
                    form={form}
                    onFinish={handleSubmit}
                >
                    {/* Header Information */}
                    <Card
                        title="মাসিক তথ্য"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                    >
                        <Row gutter={24}>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="মাস">
                                    <Input
                                        value={month1}
                                        onChange={(e) => setMonth1(e.target.value)}
                                        placeholder="মাস"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="বছর">
                                    <Input
                                        value={year1}
                                        onChange={(e) => setYear1(e.target.value)}
                                        placeholder="বছর"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="তারিখ ১">
                                    <Input
                                        value={date1}
                                        onChange={(e) => setDate1(e.target.value)}
                                        placeholder="তারিখ ১"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={6}>
                                <Form.Item label="তারিখ ২">
                                    <Input
                                        value={date2}
                                        onChange={(e) => setDate2(e.target.value)}
                                        placeholder="তারিখ ২"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* Section 1 - High Court */}
                    <Card
                        title="উচ্চ আদালতে (সুপ্রীম কোর্ট) চলমান মামলার তালিকা"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                        extra={
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => addRow(1)}
                                style={{ backgroundColor: "#4caf50", borderColor: "#4caf50" }}
                            >
                                নতুন সারি
                            </Button>
                        }
                    >
                        <div style={{ overflowX: 'auto' }}>
                            <Table
                                columns={getSection1Columns()}
                                dataSource={section1Data}
                                pagination={false}
                                size="small"
                                bordered
                                summary={() => (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={8}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
                                                    <span style={{ fontWeight: 'bold' }}>উচ্চ আদালতে চলমান মামলার মোট সংখ্যা =</span>
                                                    <Input
                                                        value={section1Total}
                                                        onChange={(e) => setSection1Total(e.target.value)}
                                                        style={{ width: 100, marginLeft: 10, textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                )}
                            />
                        </div>
                    </Card>

                    {/* Section 2 - Arbitration Tribunal */}
                    <Card
                        title="THREE-MEMBER ARBITRAL TRIBUNAL, DHAKA (Under the Arbitration Act, 2001)"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                        extra={
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => addRow(2)}
                                style={{ backgroundColor: "#4caf50", borderColor: "#4caf50" }}
                            >
                                নতুন সারি
                            </Button>
                        }
                    >
                        <div style={{ overflowX: 'auto' }}>
                            <Table
                                columns={getSection2Columns()}
                                dataSource={section2Data}
                                pagination={false}
                                size="small"
                                bordered
                            />
                        </div>
                    </Card>

                    {/* Section 3 - Lower Court */}
                    <Card
                        title="জেলা জজ আদালতসহ ট্রাইব্যুনাল ও অন্যান্য অধস্তন আদালতে চলমান মামলার তালিকা"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                        extra={
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => addRow(3)}
                                style={{ backgroundColor: "#4caf50", borderColor: "#4caf50" }}
                            >
                                নতুন সারি
                            </Button>
                        }
                    >
                        <div style={{ overflowX: 'auto' }}>
                            <Table
                                columns={getSection3Columns()}
                                dataSource={section3Data}
                                pagination={false}
                                size="small"
                                bordered
                                summary={() => (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row>
                                            <Table.Summary.Cell index={0} colSpan={8}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '8px' }}>
                                                    <span style={{ fontWeight: 'bold' }}>অধস্তন আদালতে চলমান মামলার মোট সংখ্যা =</span>
                                                    <Input
                                                        value={section3Total}
                                                        onChange={(e) => setSection3Total(e.target.value)}
                                                        style={{ width: 100, marginLeft: 10, textAlign: 'center' }}
                                                    />
                                                </div>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                )}
                            />
                        </div>
                    </Card>

                    {/* Grand Total */}
                    <Card
                        title="সর্বমোট"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                    >
                        <div style={{ textAlign: 'center', padding: '16px' }}>
                            <Title level={5}>
                                * উচ্চ আদালতে এবং অধস্তন আদালতে চলমান মামলার সর্বমোট সংখ্যা:
                            </Title>
                            <Input
                                value={grandTotal}
                                onChange={(e) => setGrandTotal(e.target.value)}
                                style={{
                                    width: 300,
                                    marginTop: 10,
                                    fontSize: 18,
                                    fontWeight: 'bold',
                                    textAlign: 'center'
                                }}
                                size="large"
                            />
                        </div>
                    </Card>

                    {/* Signatory Information */}
                    <Card
                        title="স্বাক্ষরকারীর তথ্য"
                        style={{ marginBottom: 24, borderRadius: 12 }}
                        headStyle={{ backgroundColor: "#fafafa", borderBottom: "2px solid #1a5f7a" }}
                    >
                        <Row gutter={24}>
                            <Col xs={24} md={8}>
                                <Form.Item label="নাম">
                                    <Input
                                        value={signatoryName}
                                        onChange={(e) => setSignatoryName(e.target.value)}
                                        placeholder="নাম লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="পদবি">
                                    <Input
                                        value={signatoryDesignation}
                                        onChange={(e) => setSignatoryDesignation(e.target.value)}
                                        placeholder="পদবি লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={8}>
                                <Form.Item label="প্রতিষ্ঠান">
                                    <Input
                                        value={signatoryDepartment}
                                        onChange={(e) => setSignatoryDepartment(e.target.value)}
                                        placeholder="প্রতিষ্ঠানের নাম লিখুন"
                                        size="large"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>

                    {/* Action Buttons */}
                    <Card style={{ borderRadius: 12 }}>
                        <div style={{ textAlign: 'right' }}>
                            <Space>
                                <Button
                                    size="large"
                                    icon={<ReloadOutlined />}
                                    onClick={handleReset}
                                >
                                    রিসেট করুন
                                </Button>
                                <Button
                                    type="primary"
                                    size="large"
                                    htmlType="submit"
                                    loading={submitting}
                                    icon={<SaveOutlined />}
                                    style={{ backgroundColor: "#1a5f7a", borderColor: "#1a5f7a" }}
                                >
                                    সংরক্ষণ করুন
                                </Button>
                            </Space>
                        </div>
                    </Card>
                </Form>
            </div>
        </div>
    );

    // Column definitions (keep your existing column definitions)
    function getSection1Columns() {
        return [
            { title: 'ক্রম', dataIndex: 'serial', width: 60, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'serial', e.target.value)} size="small" /> },
            { title: 'বিবরণ', dataIndex: 'division', width: 200, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'division', e.target.value)} size="small" /> },
            { title: `${month1} ${year1} মাসে দায়েরকৃত`, dataIndex: 'col1', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'col1', e.target.value)} className="text-center" size="small" /> },
            { title: `${date1} পর্যন্ত অনিষ্পত্তি`, dataIndex: 'col2', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'col2', e.target.value)} className="text-center" size="small" /> },
            {
                title: `${date2} মাসে নিষ্পত্তিকৃত`,
                children: [
                    { title: 'পক্ষে', dataIndex: 'col3', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'col3', e.target.value)} className="text-center" size="small" /> },
                    { title: 'বিপক্ষে', dataIndex: 'col4', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'col4', e.target.value)} className="text-center" size="small" /> }
                ]
            },
            { title: 'চলমান মামলার সংখ্যা', dataIndex: 'col5', width: 100, render: (text, _, index) => <Input value={text} onChange={(e) => update(1, index, 'col5', e.target.value)} className="text-center" size="small" /> },
            { title: 'মন্তব্য', dataIndex: 'remark', width: 250, render: (text, _, index) => <Input.TextArea value={text} onChange={(e) => update(1, index, 'remark', e.target.value)} rows={2} size="small" /> },
            { title: 'কার্যক্রম', width: 80, render: (_, __, index) => <Button danger icon={<DeleteOutlined />} onClick={() => removeRow(1, index)} size="small" /> }
        ];
    }

    function getSection2Columns() {
        return [
            { title: 'ক্রম', dataIndex: 'serial', width: 60, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'serial', e.target.value)} size="small" /> },
            { title: 'বিবরণ', dataIndex: 'division', width: 300, render: (text, _, index) => <Input.TextArea value={text} onChange={(e) => update(2, index, 'division', e.target.value)} rows={2} size="small" /> },
            { title: `${month1} ${year1} মাসে দায়েরকৃত`, dataIndex: 'col1', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'col1', e.target.value)} className="text-center" size="small" /> },
            { title: `${date1} পর্যন্ত অনিষ্পত্তি`, dataIndex: 'col2', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'col2', e.target.value)} className="text-center" size="small" /> },
            {
                title: `${date2} মাসে নিষ্পত্তিকৃত`,
                children: [
                    { title: 'পক্ষে', dataIndex: 'col3', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'col3', e.target.value)} className="text-center" size="small" /> },
                    { title: 'বিপক্ষে', dataIndex: 'col4', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'col4', e.target.value)} className="text-center" size="small" /> }
                ]
            },
            { title: 'চলমান মামলার সংখ্যা', dataIndex: 'col5', width: 100, render: (text, _, index) => <Input value={text} onChange={(e) => update(2, index, 'col5', e.target.value)} className="text-center" size="small" /> },
            { title: 'মন্তব্য', dataIndex: 'remark', width: 250, render: (text, _, index) => <Input.TextArea value={text} onChange={(e) => update(2, index, 'remark', e.target.value)} rows={2} size="small" /> },
            { title: 'কার্যক্রম', width: 80, render: (_, __, index) => <Button danger icon={<DeleteOutlined />} onClick={() => removeRow(2, index)} size="small" /> }
        ];
    }

    function getSection3Columns() {
        return [
            { title: 'ক্রম', dataIndex: 'serial', width: 60, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'serial', e.target.value)} size="small" /> },
            { title: 'বিবরণ', dataIndex: 'division', width: 300, render: (text, _, index) => <Input.TextArea value={text} onChange={(e) => update(3, index, 'division', e.target.value)} rows={3} size="small" /> },
            { title: `${month1} ${year1} মাসে দায়েরকৃত`, dataIndex: 'col1', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'col1', e.target.value)} className="text-center" size="small" /> },
            { title: `${date1} পর্যন্ত অনিষ্পত্তি`, dataIndex: 'col2', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'col2', e.target.value)} className="text-center" size="small" /> },
            {
                title: `${date2} মাসে নিষ্পত্তিকৃত`,
                children: [
                    { title: 'পক্ষে', dataIndex: 'col3', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'col3', e.target.value)} className="text-center" size="small" /> },
                    { title: 'বিপক্ষে', dataIndex: 'col4', width: 80, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'col4', e.target.value)} className="text-center" size="small" /> }
                ]
            },
            { title: 'চলমান মামলার সংখ্যা', dataIndex: 'col5', width: 100, render: (text, _, index) => <Input value={text} onChange={(e) => update(3, index, 'col5', e.target.value)} className="text-center" size="small" /> },
            { title: 'মন্তব্য', dataIndex: 'remark', width: 300, render: (text, _, index) => <Input.TextArea value={text} onChange={(e) => update(3, index, 'remark', e.target.value)} rows={4} size="small" /> },
            { title: 'কার্যক্রম', width: 80, render: (_, __, index) => <Button danger icon={<DeleteOutlined />} onClick={() => removeRow(3, index)} size="small" /> }
        ];
    }
};

export default EditableCaseTable;